<template>
  <section id="features" class="py-5 features-section">
    <div class="container">
      <h2 class="text-center mb-5 d-none d-lg-block scroll-reveal">盒子特色</h2>
      
      <!-- PC端标签页 -->
      <div class="feature-tabs-container d-none d-lg-block scroll-reveal">
        <div class="feature-tabs">
          <div 
            v-for="(item, index) in featureData" 
            :key="index"
            :class="['feature-tab', 'animated-tab', { active: activeTab === index }]"
            @click="switchTab(index)"
            :style="{ animationDelay: `${index * 0.1}s` }"
          >
            <div class="feature-tab-inner">
              <div class="feature-text-container">
                <div class="feature-text">{{ item.title }}</div>
                <div class="feature-desc">{{ item.describe }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 手机端标签页 - 图示样式 -->
      <div class="mobile-feature-tabs d-lg-none scroll-reveal">
        <div 
          v-for="(item, index) in featureData" 
          :key="index"
          :class="['mobile-feature-tab', 'animated-mobile-tab', { active: activeTab === index }]"
          @click="switchTab(index)"
          :style="{ animationDelay: `${index * 0.1}s` }"
        >
          <div class="mobile-feature-text">{{ item.title }}</div>
        </div>
      </div>

      <!-- PC端内容 -->
      <div 
        class="tab-content feature-content scroll-reveal d-none d-lg-block"
      >
        <div 
          v-for="(item, index) in featureData" 
          :key="index"
          :class="['tab-pane', 'fade', { 'show active': activeTab === index }]"
          :id="`tab${index + 1}`"
        >
          <div class="feature-detail">
            <div class="feature-image animated-image">
              <video 
                v-if="item.file_type == 2"
                :src="item.file"
                autoplay 
                muted 
                controls
                @ended="onVideoEnded"
                @loadeddata="onVideoLoaded"
              >
                您的浏览器不支持视频播放
              </video>
              <img 
                v-else
                :src="item.file" 
                :alt="item.title"
                @load="onImageLoaded"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 手机端轮播图 -->
      <div 
        class="mobile-carousel-container d-lg-none scroll-reveal"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
        ref="mobileCarousel"
      >
        <div 
          class="mobile-carousel-wrapper"
          :style="{ 
            transform: carouselTransform,
            width: `${(featureData.length + 2) * 100}%`,
            transition: isTransitioning ? 'none' : 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
          }"
        >
          <!-- 克隆最后一个幻灯片放在开头 -->
          <div 
            v-if="featureData.length > 0"
            class="mobile-carousel-slide"
            :style="{ width: `${100 / (featureData.length + 2)}%` }"
          >
            <div class="mobile-feature-describe">{{ featureData[featureData.length - 1].describe }}</div>
            <div class="mobile-feature-detail">
              <div class="mobile-feature-image">
                <video 
                  v-if="featureData[featureData.length - 1].file_type == 2"
                  :src="featureData[featureData.length - 1].file"
                  autoplay 
                  muted 
                  controls
                  @ended="onVideoEnded"
                  @loadeddata="onVideoLoaded"
                >
                  您的浏览器不支持视频播放
                </video>
                <img 
                  v-else
                  :src="featureData[featureData.length - 1].file" 
                  :alt="featureData[featureData.length - 1].title"
                  @load="onImageLoaded"
                />
              </div>
            </div>
          </div>
          
          <!-- 原始幻灯片 -->
          <div 
            v-for="(item, index) in featureData" 
            :key="`original-${index}`"
            class="mobile-carousel-slide"
            :style="{ width: `${100 / (featureData.length + 2)}%` }"
          >
            <div class="mobile-feature-describe">{{ item.describe }}</div>
            <div class="mobile-feature-detail">
              <div class="mobile-feature-image">
                <video 
                  v-if="item.file_type == 2"
                  :src="item.file"
                  autoplay 
                  muted 
                  controls
                  @ended="onVideoEnded"
                  @loadeddata="onVideoLoaded"
                >
                  您的浏览器不支持视频播放
                </video>
                <img 
                  v-else
                  :src="item.file" 
                  :alt="item.title"
                  @load="onImageLoaded"
                />
              </div>
            </div>
          </div>
          
          <!-- 克隆第一个幻灯片放在末尾 -->
          <div 
            v-if="featureData.length > 0"
            class="mobile-carousel-slide"
            :style="{ width: `${100 / (featureData.length + 2)}%` }"
          >
            <div class="mobile-feature-describe">{{ featureData[0].describe }}</div>
            <div class="mobile-feature-detail">
              <div class="mobile-feature-image">
                <video 
                  v-if="featureData[0].file_type == 2"
                  :src="featureData[0].file"
                  autoplay 
                  muted 
                  controls
                  @ended="onVideoEnded"
                  @loadeddata="onVideoLoaded"
                >
                  您的浏览器不支持视频播放
                </video>
                <img 
                  v-else
                  :src="featureData[0].file" 
                  :alt="featureData[0].title"
                  @load="onImageLoaded"
                />
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesSection',
  data() {
    return {
      activeTab: 0,
      // 移动端滑动相关状态
      touchStartX: 0,
      touchStartY: 0,
      touchEndX: 0,
      touchEndY: 0,
      // 自动切换相关状态
      autoSwitchTimer: null,
      isAutoSwitching: true,
      featureData: [],
      // 无缝循环相关状态
      isTransitioning: false,
      realActiveTab: 0
    }
  },
  computed: {
    carouselTransform() {
      if (this.featureData.length === 0) return 'translateX(0%)'
      // 无缝循环：总共有 length + 2 个slide（包括克隆的首尾slide）
      // activeTab从1开始（因为第0个是克隆的最后一个slide）
      const totalSlides = this.featureData.length + 2
      const slideWidthPercent = 100 / totalSlides
      const displayIndex = this.activeTab + 1 // 偏移1位，因为第0个是克隆slide
      return `translateX(${-displayIndex * slideWidthPercent}%)`
    }
  },
  methods: {
    switchTab(index) {
      this.activeTab = index
      // 手动切换时重新启动自动切换
      this.startAutoSwitchForCurrentTab()
    },
    
    // 视频播放完成事件
    onVideoEnded() {
      if (this.isAutoSwitching) {
        this.autoSwitchToNext()
      }
    },

    // 视频加载完成事件
    onVideoLoaded() {
      // 清除之前的定时器
      this.clearAutoSwitchTimer()
    },

    // 图片加载完成事件
    onImageLoaded() {
      if (this.isAutoSwitching) {
        // 图片展示10秒后切换
        this.startImageTimer()
      }
    },
    
    async loadFeatureData() {
      // 这里可以调用API获取数据
      const response = await this.$ajax('/common/officialFeature')
      this.featureData = response.data
    },

    // 触摸事件处理
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX
      this.touchStartY = e.touches[0].clientY
      // 停止自动切换
      this.clearAutoSwitchTimer()
    },

    handleTouchMove(e) {
      // 简化处理：只阻止默认滚动行为
      const currentX = e.touches[0].clientX
      const currentY = e.touches[0].clientY
      const deltaX = currentX - this.touchStartX
      const deltaY = currentY - this.touchStartY
      
      // 如果是水平滑动，阻止默认行为
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        e.preventDefault()
      }
    },

    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].clientX
      this.touchEndY = e.changedTouches[0].clientY
      
      this.handleSwipe()
      
      // 重新启动自动切换
      this.startAutoSwitchForCurrentTab()
    },



    // 处理滑动逻辑
    handleSwipe() {
      const deltaX = this.touchEndX - this.touchStartX
      const deltaY = this.touchEndY - this.touchStartY
      const containerWidth = this.$refs.mobileCarousel?.offsetWidth || 1
      const minSwipeDistance = Math.min(50, containerWidth * 0.1) // 动态最小滑动距离
      
      // 确保是水平滑动而不是垂直滑动
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
        if (deltaX > 0) {
          // 向右滑动 - 切换到上一个tab
          this.switchToPrevTab()
        } else {
          // 向左滑动 - 切换到下一个tab
          this.switchToNextTab()
        }
      }
    },

    // 切换到上一个tab（无缝循环）
    switchToPrevTab() {
      if (this.activeTab > 0) {
        this.activeTab--
      } else {
        // 无缝循环：先跳到克隆的最后一个slide，然后无动画切换到真正的最后一个slide
        this.activeTab = -1 // 跳到克隆的最后一个slide
        this.$nextTick(() => {
          setTimeout(() => {
            this.isTransitioning = true
            this.activeTab = this.featureData.length - 1
            this.$nextTick(() => {
              setTimeout(() => {
                this.isTransitioning = false
              }, 50)
            })
          }, 300) // 等待动画完成
        })
      }
    },

    // 切换到下一个tab（无缝循环）
    switchToNextTab() {
      if (this.activeTab < this.featureData.length - 1) {
        this.activeTab++
      } else {
        // 无缝循环：先跳到克隆的第一个slide，然后无动画切换到真正的第一个slide
        this.activeTab = this.featureData.length // 跳到克隆的第一个slide
        this.$nextTick(() => {
          setTimeout(() => {
            this.isTransitioning = true
            this.activeTab = 0
            this.$nextTick(() => {
              setTimeout(() => {
                this.isTransitioning = false
              }, 50)
            })
          }, 300) // 等待动画完成
        })
      }
    },

    // 自动切换到下一个tab
    autoSwitchToNext() {
      this.clearAutoSwitchTimer()
      this.switchToNextTab()
      this.startAutoSwitchForCurrentTab()
    },

    // 开始图片定时器（10秒）
    startImageTimer() {
      this.clearAutoSwitchTimer()
      this.autoSwitchTimer = setTimeout(() => {
        this.autoSwitchToNext()
      }, 10000) // 10秒
    },

    // 清除自动切换定时器
    clearAutoSwitchTimer() {
      if (this.autoSwitchTimer) {
        clearTimeout(this.autoSwitchTimer)
        this.autoSwitchTimer = null
      }
    },

    // 为当前tab启动自动切换
    startAutoSwitchForCurrentTab() {
      if (!this.isAutoSwitching) return
      
      const currentItem = this.featureData[this.activeTab]
      if (currentItem && currentItem.file_type != 2) {
        // 如果是图片，启动10秒定时器
        this.startImageTimer()
      }
      // 如果是视频，会在视频播放完成时自动切换
    },

    // 暂停自动切换
    pauseAutoSwitch() {
      this.isAutoSwitching = false
      this.clearAutoSwitchTimer()
    },

    // 恢复自动切换
    resumeAutoSwitch() {
      this.isAutoSwitching = true
      this.startAutoSwitchForCurrentTab()
    },

    // 初始化滚动动画
    initScrollAnimation() {
      // 使用Intersection Observer API监听元素进入视口
      if ('IntersectionObserver' in window) {
        this.scrollObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('animate-in')
            }
          })
        }, {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        })

        // 监听所有需要动画的元素
        this.$nextTick(() => {
          const elements = this.$el.querySelectorAll('.scroll-reveal')
          elements.forEach(el => {
            this.scrollObserver.observe(el)
          })
        })
      } else {
        // 降级处理：直接添加动画类
        this.$nextTick(() => {
          const elements = this.$el.querySelectorAll('.scroll-reveal')
          elements.forEach(el => {
            el.classList.add('animate-in')
          })
        })
      }
    }
  },
  
  mounted() {
    this.loadFeatureData()
    // 启动自动切换
    this.$nextTick(() => {
      this.startAutoSwitchForCurrentTab()
      this.initScrollAnimation()
    })
  },

  beforeDestroy() {
    // 组件销毁前清除定时器
    this.clearAutoSwitchTimer()
    // 移除滚动监听
    if (this.scrollObserver) {
      this.scrollObserver.disconnect()
    }
  }
}
</script>

<style lang="scss" scoped>
/* Features区域整体动画 */
.features-section {
  overflow: hidden;
}

/* 滚动进入动画基础样式 */
.scroll-reveal {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.scroll-reveal.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* 标题动画 */
.scroll-reveal h2 {
  background: linear-gradient(45deg, #007bff, #0056b3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.scroll-reveal.animate-in h2 {
  animation: titleGlow 2s ease-in-out infinite alternate;
}

@keyframes titleGlow {
  from {
    filter: brightness(1);
  }
  to {
    filter: brightness(1.2);
  }
}

/* PC端标签页动画 */
.animated-tab {
  opacity: 0;
  transform: translateX(-20px);
  transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.scroll-reveal.animate-in .animated-tab {
  opacity: 1;
  transform: translateX(0);
}

.feature-tab {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
}

.feature-tab.active {
  transform: scale(1.02);
}

.feature-tab-inner {
  transition: all 0.3s ease;
}

.feature-tab:hover .feature-tab-inner {
  transform: scale(1.02);
}

/* 内容区域动画 */
.feature-content {
  position: relative;
  overflow: hidden;
}

/* 视频和图片样式 */
.feature-image {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 12px;
}

.animated-image {
  opacity: 0;
  transform: scale(0.9) translateY(20px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.tab-pane.show.active .animated-image {
  opacity: 1;
  transform: scale(1) translateY(0);
}

.feature-image video,
.feature-image img {
  width: 100%;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 123, 255, 0.15);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  will-change: transform, box-shadow;
}

/* 图片加载动画 */
.feature-image video,
.feature-image img {
  animation: imageLoad 0.6s ease-out;
}

@keyframes imageLoad {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* 自动切换指示器 */
.auto-switch-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 10;
}

/* 手机端轮播图样式 */
.mobile-carousel-container {
  position: relative;
  overflow: hidden;
  margin-top: 5px;
  border-radius: 12px;
}

.mobile-carousel-wrapper {
  display: flex;
  will-change: transform;
}

.mobile-carousel-slide {
  flex-shrink: 0;
  box-sizing: border-box;
}

.mobile-feature-detail {
  width: 100%;
  height: calc(100% - 60px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.mobile-feature-image {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 12px;
  position: relative;
}

.mobile-feature-describe {
  color: #FFEAB3;
  text-align: center;
  font-size: 1rem;
  font-weight: 500;
  padding: 10px 16px;
  margin-bottom: 10px;
}

.mobile-feature-image video,
.mobile-feature-image img {
  width: 100%;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 123, 255, 0.15);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 手机端轮播指示器 */
.mobile-carousel-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  gap: 8px;
}

.mobile-carousel-indicators .indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(0, 123, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-carousel-indicators .indicator.active {
  background: #007bff;
  transform: scale(1.2);
}

.mobile-carousel-indicators .indicator:hover {
  background: rgba(0, 123, 255, 0.6);
}

</style>